import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from "../../../../core/api-links/api-links";
import {isEmpty, get, capitalize, head} from 'lodash';
import { CustomerService } from "../../../../providers/customer.service";
import { InformationModalComponent } from 'src/app/shared/components/information-modal/information-modal.component';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import * as fs from 'file-saver';
import { DownloaderLoaderComponent } from 'src/app/shared/components/downloader-loader/downloader-loader.component';
import { ActivatedRoute, Router } from '@angular/router';
import { UserType } from "../../../../core/model/user-type.enum";
import { AuthService } from 'src/app/providers/auth.service';

@Component({
  selector: 'app-billing-invoice',
  templateUrl: './billing-invoice.component.html',
  styleUrls: ['./billing-invoice.component.scss']
})
export class BillingInvoiceComponent implements OnInit {

  page = 1;
  limit = 20;
  size = 20;
  total: number;
  totalPages: number;
  totalPage: number;
  isPagination = false;
  billingInvoiceListViewSub: Subscription;
  billingInvoiceListData: any;
  viewMode: number = 0;
  isLoading: boolean;
  billingInvoiceListUnFilteredData: any;
  masterCollectionSize: any;
  collectionSize: any;
  viewInvoice: any;
  displayFixedFee = 0;
  displaySetUpFixedFee = 0;
  isDownloadStatus: boolean = false;
  eventsSubject: Subject<void> = new Subject<void>();
  isShow: boolean = false;
  searchTerm: '';
  filterQuery: any;
  statusTypes = [];
  startYear = 2022;
  yearList:Number[] = [];
  // selectedMonth = Number(moment().format("M")) -1;
  selectedMonth;
  selectedYear: any;
  validMonthYear = false;
  modalReference: NgbModalRef;
  paramDestination: any;
  currentInvoiceType = this.router.url.split('/').pop();
  monthList = moment.months().map((data, index) => {
    return {label:data, value: index};
  });
  isDisableEditInvoice:boolean = false;

  constructor(
    private commonService: CommonService,
    private messageService: MessageService,
    private CustomerService: CustomerService,
    private ngbModal: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.currentInvoiceType = this.router.url.split('?')[0].split('/').pop();
    this.filterQuery = {invoiceType:this.currentInvoiceType};
  
    this.jumpFromCustomersInvoiceGeneration();
    // this.getInvoiceDetails({ isFilter: false, page: this.page, size: this.size });
    this.isLoading = true;
    let selectedYear = Number(moment().format("YYYY"));
    for(let i = this.startYear; i <= selectedYear; i++) {
      this.yearList.push(i);
    }
    let usersRoleType = this.authService.getUserRoleType()

    if( usersRoleType?.userType === UserType.SYSTEM ){
      this.isDisableEditInvoice = true;
    } 
  }

  status = ['COMMITTED','UNCOMMITTED','APPROVED','DECLINED'
    // { id: '0', name: 'COMMITTED' },
    // { id: '1', name: 'UNCOMMITTED' },
    // { id: '2', name: 'APPROVED' },
    // { id: '3', name: 'DECLINED' },
  ];

  selectedFilter(data, propertyName) {
    this.filterQuery['isFilter'] = true;
    this.filterQuery['size'] = 20;
    this.filterQuery['invoiceType'] =this.currentInvoiceType;
    if(isEmpty(data) && data == '') {
      this.filterQuery[propertyName] = "";
    }
    else if(propertyName === 'status') {
      this.filterQuery[propertyName] = (data);
    }
    else if(propertyName === 'year'){
      this.filterQuery[propertyName] = (data);
    }
    else if(propertyName === 'month'){
      this.filterQuery[propertyName] = (data?.value + 1);
    }
    else if(propertyName === 'queryString') {
      this.filterQuery[propertyName] = data?.data != null ? data?.data : data?.data != undefined ? data?.data : ''
    }
    
    if(this.searchTerm){
      this.filterQuery['queryString'] = this.searchTerm;
    }
    this.page = 1;
    this.getInvoiceDetails( { isFilter: true, page:this.page, ...this.filterQuery});
  }

  clear() {
    this.filterQuery = {'hostResponseCode':'', year:'', month:'', status:'','invoiceType':this.currentInvoiceType};
    this.selectedYear = [];
    this.statusTypes = [];
    this.selectedMonth=[];
    this.eventsSubject.next();
    this.page = 1;
    this.getInvoiceDetails( { isFilter: false, page:this.page, size: this.size, ...this.filterQuery});
  }

  getInvoiceDetails(filter) {
    this.billingInvoiceListViewSub = this.commonService.getCommonHttpClientQueryParams(apiLinks.getAllBillingInvoice, filter).subscribe(res => {
      this.isLoading = false;
      this.isPriorityLoading = false;
      this.billingInvoiceListUnFilteredData = this.billingInvoiceListData = res.data.items;
      this.masterCollectionSize = this.collectionSize = res.data.totalItems;
      this.messageService.clear();
      this.setViewInvoice(this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : []);
      this.viewMode = 0;
      this.isCommitButtonDisabled();
      if (isEmpty(this.billingInvoiceListData)) {
        this.messageService.clear();
        this.showNoDataMessage();
      }
    },
      (err) => {
        this.showAlert(err, "error");
      }
    )
  }

  getPage(page: number) {
    this.page = page;
    this.getInvoiceDetails({ isFilter: false, page: this.page, size: this.size, ...this.filterQuery });
  }

  applyFilters(filteredData) {
    // this.getInvoiceList(filteredData);
    let {data, searchTerm} = filteredData;
    this.searchTerm=searchTerm;
    this.page = 1;
    if(!isEmpty(data)) {
      this.billingInvoiceListData = data.data.items;
      this.setViewInvoice(this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : []);
      this.isCommitButtonDisabled();
      this.viewMode = 0;
      this.collectionSize = data.data.totalItems;
      this.total = data.data.totalItems;
    } else {
      this.billingInvoiceListData = this.billingInvoiceListUnFilteredData;
      if(this.billingInvoiceListData){
        this.setViewInvoice(this.billingInvoiceListData.length > 0 ? this.billingInvoiceListData[0] : []);
        this.isCommitButtonDisabled();
      }
      this.viewMode = 0;
      this.collectionSize = this.masterCollectionSize;
      this.total = this.totalPage;
    }
    if (isEmpty(this.billingInvoiceListData) && !isEmpty(data)) {
      this.messageService.clear();
      this.showNoDataMessage();
    }
  }

  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  getUserDetails(invoice) {
    this.setViewInvoice(invoice);
    this.isCommitButtonDisabled();
  }

  setViewInvoice(invoice: any) {
    this.viewInvoice = invoice;
    const splitUpJSON = invoice?.splitUpJSON;
    this.displayFixedFee = this.combinedSplitUpFee(splitUpJSON, 'fixedFee', 'unattendedFixedFee');
    this.displaySetUpFixedFee = this.combinedSplitUpFee(splitUpJSON, 'setUpFixedFee', 'unattendedSetUpFixedFee');
  }

  showNoDataMessage() {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Sorry! No Invoice exists.',
      sticky: true
    });
  }

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
  }

  selected(index) {
    this.viewMode = index;
  }

  refreshPage() {
    // this.refreshUsers$.next(true);
    this.getInvoiceDetails({page:this.page, size: 20, ...this.filterQuery})
  }

  openLoaderModal(bodyContent="Downloading"){
    window.scroll(0,0);
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      centered: true,
      size: 'lg',
    };
    this.modalReference =  this.ngbModal.open(DownloaderLoaderComponent, ngbModalOptions);
    this.modalReference.componentInstance.isLoading = true;
    this.modalReference.componentInstance.body = bodyContent;
  }
  
  async downLoadISOInvoice(isDownLoad:Boolean,loaderBodyContent="Downloading") {
    const { isoId, month, year, excelFileLocation, priorityId, id    } = this.viewInvoice;
    console.log('...priorityId...', priorityId);
    if(excelFileLocation == "NA") {
      this.openLoaderModal(loaderBodyContent);
      this.isDownloadStatus = true;
      let payLoad = { isoId, month, year, action: 'invoiceBillingExcelData', isPPICustId:!isEmpty(priorityId) };
      let excelData = await this.commonService.getCommonHttpClientQueryParams(this.CustomerService.calculateISOMonthlyBillingSummary,
        payLoad).toPromise().then(
          ({ message: data }) => {
            if (data) {
              // this.invoiceConfirmationModal.close();
              // this.isCreateContractLoading = false;
              // this.showAlert({status:'success', message}, 'success');
              if(isDownLoad) {
                this.download({...data, isPPICustId:payLoad.isPPICustId});
              } else {
                return data;
              }
            }
          },
          async(err) => {
            await this.updateInvoiceStatus({ invoiceId: id, status: "UNCOMMITTED" });
            this.isDownloadStatus = false;
            this.modalReference.close();
            this.refreshPage();
            this.showAlert({ status: err.status, message: err.message }, "error");
          });
          if(!isDownLoad) {
            return excelData;
          }
    } else {
      this.downLoadISOInvoiceBill("excel");
    }
  }

  download(data: { summary: any; details: any; merchantSummary: any; storeSummary: any, assetProtectionDetails: any, assetProtectionTotal: 0 , isPPICustId: boolean, storeFeeData: {}, unattendedFeeData?: any, showUnattendedBilling?: boolean}) {
    this.isDownloadStatus = false;
    const { invoiceNumber, month, year } = this.viewInvoice;
    let summary = [this.withCombinedUnattendedSummary(data.summary)];
    head(summary).assetProtectionTotal = data.assetProtectionTotal;
    let fileName = `${data.summary.isoName}-${month}-${year}.xlsx`;
    const showUnattendedBilling = !!(data.showUnattendedBilling || data.summary?.showUnattendedBilling);
    const unattendedSetupColumns = showUnattendedBilling ? [
            { header: "Primary Unattended setup fee", key: "unattendedPrimarySetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on Unattended setup fee", key: "unattendedAddOnSetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
          ] : [];
    const unattendedTxColumns = showUnattendedBilling ? [
            { header: "# of Unattended Tx", key: "unattendedTx", width: 15 },
            { header: "Unattended volume", key: "unattendedTxVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Unattended Contract rate per Tx", key: "unattendedTxContractFeePerTx", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Unattended Contract rate on volume", key: "unattendedTxContractVolPerTx", width: 15 , style:{numFmt:'0.00%'}},
            { header: "Unattended Tx Fee", key: "unattendedTxFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Unattended Volume Fee", key: "unattendedTxVolFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
          ] : [];
    const unattendedSummaryColumns = showUnattendedBilling ? [
            { header: "Unattended Variable Fee", key: "unattendedVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
          ] : [];
    let worksheetData = {
      "worksheet": [
        {
          "name": 'Details',
          "columns": [
            { header: "ISO DBA", key: "isoDba", width: 25 },
            { header: "Agent Office", key: "subIsoDba", width: 25 },
            { header: "Merchant DBA", key: "merchantDba", width: 25 },
            { header: "Store DBA", key: "storeName", width: 25 },
            { header: "ISO Reference", key: "isoReference", width: 25 },
            { header: "Merchant Reference", key: "merchantReference", width: 25 },
            { header: "Month/Year", key: "monthYear", width: 10 },
            { header: "TPN #", key: "tpn#", width: 15, style: { numFmt: '0' } },
            { header: "Unused TPN", key: "unusedTpn", width: 12 },
            { header: "Model", key: "device", width: 15 },
            { header: "Serial #", key: "serialNumber", width: 15 },
            { header: "Mid", key: "mid", width: 15 },
            { header: "Activated On", key: "activatedOn", width: 13 },
            { header: "Deactivated On", key: "deactivatedOn", width: 13 },
            { header: "Bill as ( Primary/Add-on)", key: "billAs", width: 10 },
            { header: "# of billing days", key: "noOfBillingDays", width: 10 },
            { header: "Primary TPN Contract rate", key: "primaryTpnContractFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on Contract rate", key: "addOnTpnContractFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Fixed Fee", key: "fixedFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Spin (Primary/Add-on)", key: "isPrimarySpin", width: 25 },
            { header: "Primary Spin rate", key: "spinPrimaryFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on Spin rate", key: "spinAddOnFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Spin Fee", key: "spinFixedFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Setup Fee As(Primary/Add-on)", key: "isSetupStatus", width: 25 },
            { header: "Primary CloudPOS setup fee", key: "cPosPrimarySetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on CloudPOS setup fee", key: "cPosAddOnSetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Primary POS setup fee", key: "posPrimarySetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on POS setup fee", key: "posAddOnSetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Primary TOP Andriod setup fee", key: "topPrimarySetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on TOP Andriod setup fee", key: "topAddOnSetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Primary TOP iOS setup fee", key: "topIosPrimarySetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Add-on TOP iOS setup fee", key: "topIosAddOnSetUpFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            ...unattendedSetupColumns,
            { header: "Setup Fee", key: "setUpFixedFee", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "# of Cloudpos Tx", key: "cPosTx", width: 10 },
            { header: "CloudPOS Volume", key: "cPosVol", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "CloudPOS Contract rate per Tx", key: "cPosTxContractFeePerTx", width: 10, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "CloudPOS Contract rate on volume", key: "cPosTxContractVolPerTx", width: 10, style:{numFmt:'0.00%'} },
            { header: "CloudPOS Tx Fee", key: "cPosTxFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "CloudPOS Volume Fee", key: "cPosTxVolFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "# of TOP Andriod Tx", key: "topTx", width: 15 },
            { header: "TOP Andriod volume", key: "topVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP Andriod Contract rate per Tx", key: "topTxContractFeePerTx", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP Andriod Contract rate on volume", key: "topTxContractVolPerTx", width: 15 , style:{numFmt:'0.00%'}},
            { header: "TOP Andriod Tx Fee", key: "topTxFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP Andriod Volume Fee", key: "topTxVolFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "# of POS Tx", key: "posTx", width: 15 },
            { header: "POS volume", key: "posVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "POS Contract rate per Tx", key: "posTxContractFeePerTx", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "POS Contract rate on volume", key: "posTxContractVolPerTx", width: 15 , style:{numFmt:'0.00%'}},
            { header: "POS Tx Fee", key: "posTxFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "POS Volume Fee", key: "posTxVolFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            ...unattendedTxColumns,
            { header: "# of TOP iOS Tx", key: "topIosTx", width: 15 },
            { header: "TOP iOS volume", key: "topIosVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP iOS Contract rate per Tx", key: "topIosTxContractFeePerTx", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP iOS Contract rate on volume", key: "topIosTxContractVolPerTx", width: 15 , style:{numFmt:'0.00%'}},
            { header: "TOP iOS Tx Fee", key: "topIosTxFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP iOS Volume Fee", key: "topIosTxVolFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "# of Tx SMS", key: "txSMS", width: 15 },
            { header: "# of Promo SMS", key: "promotionalSMS", width: 15 },
            { header: "Contract - Tx SMS", key: "txSmsContractFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Contract - Promo SMS", key: "promotionalSmsContractFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Tx SMS Fee", key: "txSmsFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Promo SMS Fee", key: "promotionalSmsFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Primary TPN Fee", key: "qbPrimaryTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Add-On TPN Fee", key: "qbAddOnTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Per Txn Fee", key: "qbPerTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Capped Fee ", key: "qbMaxTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Txn Vol Fee", key: "qbTxnVolFee", width: 15 , style:{numFmt:'0.00%'}},
            {header: "QB Total Txn", key: "qbTotalTxn", width: 15},
            {header: "QB Total Txn Vol", key: "qbTotalTxnVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "QB Total Fee", key: "qbTotalVasFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "L2L3 Primary TPN Fee", key: "l2l3PrimaryTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "L2L3 Add-On TPN Fee", key: "l2l3AddOnTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "L2L3 Per Txn Fee", key: "l2l3PerTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "L2L3 Txn Vol Fee", key: "l2l3TxnVolFee", width: 15 , style:{numFmt:'0.00%'}},
            {header: "L2L3 Total Txn", key: "l2l3TotalTxn", width: 15},
            {header: "L2L3 Total Txn Vol", key: "l2l3TotalTxnVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "L2L3 Total Fee", key: "l2l3TotalVasFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "ECOM Primary TPN Fee", key: "ecomPrimaryTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "ECOM Add-On TPN Fee", key: "ecomAddOnTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "ECOM Per Txn Fee", key: "ecomPerTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "ECOM Txn Vol Fee", key: "ecomTxnVolFee", width: 15 , style:{numFmt:'0.00%'}},
            {header: "ECOM Total Txn", key: "ecomTotalTxn", width: 15},
            {header: "ECOM Total Txn Vol", key: "ecomTotalTxnVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "ECOM Total Fee", key: "ecomTotalVasFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "IBS Primary TPN Fee", key: "ibsPrimaryTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "IBS Add-On TPN Fee", key: "ibsAddOnTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "IBS Per Txn Fee", key: "ibsPerTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "IBS Txn Vol Fee", key: "ibsTxnVolFee", width: 15 , style:{numFmt:'0.00%'}},
            {header: "IBS Total Txn", key: "ibsTotalTxn", width: 15},
            {header: "IBS Total Txn Vol", key: "ibsTotalTxnVol", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "IBS Total Fee", key: "ibsTotalVasFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "3DS Primary TPN Fee", key: "threedsPrimaryTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "3DS Add-On TPN Fee", key: "threedsAddOnTpnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "3DS Per Txn Fee", key: "threedsPerTxnFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            {header: "3DS Total Txn", key: "threedsTotalTxn", width: 15},
            {header: "3DS Total Fee", key: "threedsTotalVasFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "VAS Integration Fee", key: "vasIntegrationFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Total", key: "totalBilledAmt", width: 20 , style:{numFmt:'$#,##0.00;[Red]-$#,##0.00',font:{bold: true,}}},
          ],
          "rows": data.details,
          "isRow": 0,
          frozen:true
        },
        {
          name: "Store Summary",
          "columns": [
            { header: "ISO DBA", key: "isoDba", width: 25 },
            { header: "Merchant DBA", key: "merchantDBA", width: 15 },
            { header: "Store DBA", key: "storeDba", width: 15 },
            { header: "ISO Reference", key: "isoReference", width: 25 },
            { header: "Merchant Reference", key: "merchantReference", width: 25 },
            { header: "# of TPNs", key: "tpnCount", width: 15 },
            { header: "Fixed Fee", key: "fixedFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "Spin Fee", key: "spinFixedFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "Setup Fee", key: "setUpFixedFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "CloudPos Variable Fee", key: "cPosVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "Pos Variable Fee", key: "posVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "TOP Andriod Variable Fee", key: "topVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "TOP iOS Variable Fee", key: "topIosVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            ...unattendedSummaryColumns,
            { header: "Tx SMS Fee", key: "smsVariableFee", width: 15, style: { numFmt: '$#,##0.0000;[Red]-$#,##0.0000' } },
            { header: "VAS Integration Fee", key: "vasIntegrationFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Total", key: "total", width: 15, style: { numFmt: '$#,##0.00;[Red]-$#,##0.00', font: { bold: true, } } }
          ],
          "rows": data.storeSummary,
          "isRow": 0,
          frozen: true
        },
        {
          name: "Merchant Summary",
          "columns": [
            { header: "ISO DBA", key: "isoDBA", width: 25 },
            { header: "Merchant DBA", key: "merchantDBA", width: 15 },
            { header: "ISO Reference", key: "isoReference", width: 25 },
            { header: "Merchant Reference", key: "merchantReference", width: 25 },
            { header: "# of TPNs", key: "tpnCount", width: 15 },
            { header: "Fixed Fee", key: "fixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Spin Fee", key: "spinFixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Setup Fee", key: "setUpFixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "CloudPos Variable Fee", key: "cPosVariableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Pos Variable Fee", key: "posVariableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP Andriod Variable Fee", key: "topVariableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "TOP iOS Variable Fee", key: "topIosVariableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            ...unattendedSummaryColumns,
            { header: "Tx SMS Fee", key: "smsVariableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "VAS Integration Fee", key: "vasIntegrationFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Total", key: "total", width: 15, style:{numFmt:'$#,##0.00;[Red]-$#,##0.00',font:{bold: true,}} }
          ],
          "rows": data.merchantSummary,
          "isRow": 0,
          frozen:true
        },
        {
          name: "Summary",
          "columns": [
            { header: "ISO DBA", key: "isoName", width: 25 },
            { header: "# of Merchants", key: "totalMerchant", width: 15 },
            { header: "# of TPNs", key: "totalTpn", width: 15 },
            { header: "Fixed Fee", key: "fixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Spin Fee", key: "spinFixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Setup Fee", key: "setUpFixedFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "Variable Fee", key: "variableFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "SMS Fee", key: "smsFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            // { header: "Add On SMS Fee", key: "promotionalSmsFee", width: 15, style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'} },
            { header: "VAS Integration Fee", key: "vasIntegrationFee", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Asset Protection Fee", key: "assetProtectionTotal", width: 15 , style:{numFmt:'$#,##0.0000;[Red]-$#,##0.0000'}},
            { header: "Total", key: "total", width: 15, style:{numFmt:'$#,##0.00;[Red]-$#,##0.00',font:{bold: true,}} }
          ],
          "rows": summary,
          "isRow": 0
        }
      ],
      "fileName": fileName
    };

    if (data.assetProtectionDetails && data.assetProtectionDetails.length > 0) {
      const totalAmount = data.assetProtectionTotal;
      const summaryIndex = worksheetData.worksheet.findIndex(obj => obj.name === "Summary");
      const assetProtectionSheet = {
        name: "Asset Protection",
        "columns": [
          { header: "ISO DBA", key: "isoDBA", width: 25 },
          { header: "Merchant DBA", key: "merchantDBA", width: 25 },
          { header: "TPN #", key: "tpn", width: 15, style: { numFmt: '0' } },
          { header: "Serial Number", key: "serialNumber", width: 25 },
          { header: "Billing Type", key: "billingType", width: 25 },
          { header: "Contract Fee", key: "contractFee", width: 15, style:{numFmt:'$#,##0.00;[Red]-$#,##0.00'} },
          { header: "Calculated Fee", key: "calculatedFee", width: 15, style:{numFmt:'$#,##0.00;[Red]-$#,##0.00', font:{bold: true}} },
        ],
        "rows": data.assetProtectionDetails,
        "isRow": 0,
        frozen: true
      };
      if(!data.isPPICustId) {
        assetProtectionSheet.rows.push({}, {});
      
        // Insert the total row after two blank rows
        assetProtectionSheet.rows.push({
          isoDBA: '', 
          merchantDBA: '', 
          tpn: '', 
          billingType: '', 
          contractFee: 'Total Amount', 
          calculatedFee: totalAmount, 
          style: { font: { bold: true }, numFmt:'$#,##0.00;[Red]-$#,##0.00' }
        });
      }
    
      worksheetData.worksheet.splice(summaryIndex, 0, assetProtectionSheet);
    }   

    this.commonService.downloadAsExcel(worksheetData, {
      storeFeeData: data.storeFeeData,
      unattendedFeeData: data.unattendedFeeData,
    }).then(res => {
      this.modalReference.close();
    });
  }

  combinedSplitUpFee(splitUpJSON, attendedKey: string, unattendedKey: string): number {
    return Number(get(splitUpJSON, attendedKey, 0) || 0) + Number(get(splitUpJSON, unattendedKey, 0) || 0);
  }

  withCombinedUnattendedSummary(summary: any) {
    if (!summary) return summary;
    const { unattendedFixedFee, unattendedSetUpFixedFee, ...rest } = summary;
    return {
      ...rest,
      fixedFee: this.combinedSplitUpFee(summary, 'fixedFee', 'unattendedFixedFee'),
      setUpFixedFee: this.combinedSplitUpFee(summary, 'setUpFixedFee', 'unattendedSetUpFixedFee'),
    };
  }

  getMonthName(value) {
    return this.commonService.getMonthName(value);
  }


  ngOnDestroy() {
    if (this.billingInvoiceListViewSub) this.billingInvoiceListViewSub.unsubscribe();
  }

  commitInvoice(status) {
    console.log('...this.viewInvoice....',this.viewInvoice);
    const {month, year, invoiceNumber, id, isoId, priorityId} = this.viewInvoice;
    let currentMonth = Number(moment().format("M"));
    let currentYear = Number(moment().format("YYYY"));
    let invoiceCommitAlert = `Do you want to ${capitalize(status)} the Invoice# `+invoiceNumber;
    console.log('....status...', status);
      let modalRef = this.ngbModal.open(InformationModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.header = "Invoice Confirmation";
      if(currentMonth == month && year == currentYear) {
        invoiceCommitAlert = `Do you want to proceed with ${capitalize(status)} invoice of current month (${moment().format("MMM")} - ${currentYear}).`;
        // modalRef.componentInstance.header = `Are you sure?`
      }
      modalRef.componentInstance.body = invoiceCommitAlert;
      modalRef.componentInstance.cancelButton = true;
      modalRef.componentInstance.commitButton = true;
      modalRef.componentInstance.commitButtonText = capitalize(status);
      modalRef.componentInstance.invoiceData = this.viewInvoice;
      // modalRef.componentInstance.invoiceStatus = status;
      modalRef.result.then(async (result) => {
        if (result == 'success') {
          if (status == 'COMMIT' && !isEmpty(priorityId)) {
            let fileDetails = await this.downLoadISOInvoice(false, "Uploading files");
            console.log('...fileDetails...', fileDetails);
            let payload = {
              invoiceId: id,
              s3BucketFileName: fileDetails.s3BucketFileName,
              "customerId":priorityId
            }
            console.log('....s3Status......', fileDetails.s3BucketFileName);
            this.modalReference.componentInstance.body = "Processing your request to Priority Payments";
            await this.commonService.postCommonHttpClient(apiLinks.ppiPushApi, payload).toPromise().then(async res => {
              // this.commitInvoice('PPI APPROVE');
              await this.updateInvoiceStatus({ invoiceId: id, status: "APPROVED" });
              this.isDownloadStatus = false;
              this.modalReference.close();
              console.log('.....res......', res);
              this.refreshPage();
              this.showAlert({ status: `${capitalize('APPROVED')} Invoice`, message: `Invoice ${capitalize('APPROVED')} Successfully` }, "success");
              return res;
            }, async err => {
              await this.updateInvoiceStatus({ invoiceId: id, status: "UNCOMMITTED" });
              this.isDownloadStatus = false;
              this.modalReference.close();
              console.log('......errr.........', err);
              this.refreshPage();
              this.showAlert({ status: err.status, message: err.message }, "error");
            });
            return;
          }
          this.showAlert({ status: `${capitalize(status)} Invoice`, message: `Invoice ${status} Successfully` }, "success");
          this.refreshPage();
        }
      });
  }
  enableApprovalButton(invoiceData) {
    let currentUser = JSON.parse(localStorage.getItem('current_user'));
    return !(get(invoiceData,'invoiceStatus') == 'COMMITTED' && currentUser.userTypeRole === 'FINANCE_ADMIN');
  }
  downLoadISOInvoiceBill(fileType) {
    
    this.openLoaderModal("Downloading");
      this.isDownloadStatus = true;
    this.commonService.getCommonFileDownload(apiLinks.downloadBillInvoicePDF+"/"+this.viewInvoice.id+"/"+fileType).subscribe(data => {
      let downloadURL = window.URL.createObjectURL(data);
      let fileName ="";
      if(fileType == 'pdf') {
        fileName = this.viewInvoice.pdfFileLocation.split("/");
      } else {
        fileName = this.viewInvoice.excelFileLocation.split("/");
      }
      fs.saveAs(downloadURL,fileName[fileName.length -1]);
      this.isDownloadStatus = false;
      this.modalReference.close();
    })
  }
  isNull(fileLocation) {
    return fileLocation == "NA";    
  }

  jumpFromCustomersInvoiceGeneration() {
    return this.route.queryParams.subscribe(async (param) => {
      if (isEmpty(param)) {
        this.getInvoiceDetails({ isFilter: true, page: this.page, size: this.size, ...this.filterQuery});
      } 
      else {
        // else if (param.tpn) {
          // this.paramDestination = param.route;
          this.getInvoiceDetails({ isFilter: true, page: this.page, size: this.size, status: param.status, year:param.year, month:param.month,queryString:param.queryString, ...this.filterQuery });
          
          // this.getInvoiceDetails({ isFilter: false, page: this.page, size: this.size });

        // } else if (param.dba) {
        //   this.paramDestination = param.route;
        //   this.getDeviceList({ isFilter: true, page: this.page, size: this.size, queryString: param.dba });
        // }
      }
    });
  }
  async updateInvoiceStatus(payload) {
    return this.commonService.getCommonHttpClientQueryParams(apiLinks.commitInvoice, payload).toPromise().then(res => {
      return res;            
    },
    err => {
      console.log("in err", err);
      return this.showAlert(err, 'error');
    });
  }
  
  isPriorityLoading: boolean = false;
  openPriorityIdModal() {
    this.isPriorityLoading = false;
    let modalRef = this.ngbModal.open(InformationModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.header = this.viewInvoice?.priorityId ? "Edit Priority Id" : "Add Priority Id";
    modalRef.componentInstance.editPriorityId = true;
    modalRef.componentInstance.priorityId = this.viewInvoice?.priorityId || '';
    modalRef.componentInstance.buttonName = "Save";
    modalRef.componentInstance.closeBtnName = "Close";
    modalRef.closed.subscribe((value) => {
      if(value == 'close'){
        this.isPriorityLoading = false;
      }else if (!isEmpty(value)) {
        this.isPriorityLoading = true;
        const { isoId } = this.viewInvoice;
        const payload = {
          priorityId: value,
          customerId: isoId
        }
        this.commonService.postCommonHttpClient(apiLinks.updatePriorityId, payload).toPromise().then(async res => {
          if (res?.data?.status == 'Success') {
            this.refreshPage();
            this.isCommitButtonDisabled();
          }
        },
          err => {
            console.log("in err", err);
            this.isPriorityLoading = false;
            return this.showAlert(err, 'error');
          });
      }
    })
   
  }
  isCommitEnable:boolean= false;
  isCommitButtonDisabled() {
    return  this.isCommitEnable = this.viewInvoice?.invoiceStatus !== 'UNCOMMITTED' || !this.viewInvoice?.priorityId;
  }
  get isEditDisabled(): boolean {
    return this.isDisableEditInvoice;
  }
  
  get showEditIcon(): boolean {
    return !this.isPriorityLoading;
  }
  

}
